export default "__VITE_ASSET__DZ4cn0QX__"